import { render } from "./KoruMenuItem.vue?vue&type=template&id=14e0425d"
import script from "./KoruMenuItem.vue?vue&type=script&lang=js"
export * from "./KoruMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__